import { render, staticRenderFns } from "./InstrutoresHorariosAdminPage.vue?vue&type=template&id=1af51e57"
import script from "./InstrutoresHorariosAdminPage.vue?vue&type=script&lang=js"
export * from "./InstrutoresHorariosAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports